import moment from "moment";

export function getFinancialYearDateRange(referenceDate = moment()) {
    const ref = moment(referenceDate);
    const fyStartYear = ref.month() >= 2 ? ref.year() : ref.year() - 1;
    const fromMoment = moment({ year: fyStartYear, month: 2, day: 1 });
    const toMoment = moment({ year: fyStartYear + 1, month: 2, day: 1 }).endOf("month");

    return {
        from: fromMoment.format("DD-MM-YYYY 00:00:00"),
        to: toMoment.format("DD-MM-YYYY 23:59:59"),
        label: `${fromMoment.format("MMM YYYY")} - ${toMoment.format("MMM YYYY")}`,
    };
}
